// User-facing name and description of the V4 preview toggle. Shared by every
// surface that renders or references the toggle in copy (sidebar, migration
// panel, feature-preview gating messages) so a rename stays in sync.
export const V4_PREVIEW_LABEL = "V4 preview";
export const V4_PREVIEW_DESCRIPTION =
  "Get a more performant Langfuse experience. Upgrade SDKs to the latest major for real-time data. This is a personal setting.";
